var exports = {
  "uF": "PermissionComponents.module__stateButtonsContainer___TkFYSk",
  "ev": "PermissionComponents.module__stateButton___TkFYSk",
  "uz": "PermissionComponents.module__stateButtonDisabled___TkFYSk",
  "Jj": "PermissionComponents.module__stateButtonEnabled___TkFYSk",
  "c$": "PermissionComponents.module__stateButtonDeny___TkFYSk",
  "D5": "PermissionComponents.module__stateButtonNeutral___TkFYSk",
  "N$": "PermissionComponents.module__stateButtonAllow___TkFYSk",
  "Z9": "PermissionComponents.module__stateButtonInactive___TkFYSk",
  "Ds": "PermissionComponents.module__stateDivider___TkFYSk",
  "oq": "PermissionComponents.module__overwriteToggle___TkFYSk",
  "rt": "PermissionComponents.module__overwriteToggleDense___TkFYSk",
  "HC": "PermissionComponents.module__overwriteToggleContent___TkFYSk",
  "_O": "PermissionComponents.module__overwriteToggleTitle___TkFYSk",
  "Jw": "PermissionComponents.module__overwriteToggleTitleEnabled___TkFYSk",
  "Mr": "PermissionComponents.module__overwriteToggleTitleDisabled___TkFYSk",
  "GE": "PermissionComponents.module__overwriteToggleDescription___TkFYSk",
  "fD": "PermissionComponents.module__overwriteToggleActions___TkFYSk",
  "Wk": "PermissionComponents.module__categoryContainer___TkFYSk",
  "yj": "PermissionComponents.module__categoryDivider___TkFYSk",
  "p8": "PermissionComponents.module__categoryTitle___TkFYSk",
  "LW": "PermissionComponents.module__categoryPermissions___TkFYSk",
  "wk": "PermissionComponents.module__categoryPermissionsDense___TkFYSk",
  "n2": "PermissionComponents.module__categoryPermissionsGrid___TkFYSk",
  "HF": "PermissionComponents.module__roleToggle___TkFYSk",
  "_y": "PermissionComponents.module__roleToggleDense___TkFYSk",
  "vx": "PermissionComponents.module__tooltipTriggerBlock___TkFYSk",
  "RO": "PermissionComponents.module__tooltipTriggerInline___TkFYSk",
  "Iz": "PermissionComponents.module__roleCategoryContainer___TkFYSk",
  "mj": "PermissionComponents.module__roleCategoryDivider___TkFYSk",
  "rh": "PermissionComponents.module__roleCategoryTitle___TkFYSk",
  "XC": "PermissionComponents.module__roleCategoryPermissions___TkFYSk",
  "MC": "PermissionComponents.module__roleCategoryPermissionsDense___TkFYSk",
  "bE": "PermissionComponents.module__roleCategoryPermissionsGrid___TkFYSk",
};

module.exports = exports;
